import { render } from "./place.vue?vue&type=template&id=934ceb38&scoped=true"
import script from "./place.vue?vue&type=script&lang=js"
export * from "./place.vue?vue&type=script&lang=js"

import "./place.vue?vue&type=style&index=0&id=934ceb38&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/funfindhk20250610/front-vue-src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-934ceb38"]])

export default __exports__